import { AuthorHero, AuthorHeroProps } from "~/components/AuthorHero";
import { ReadMorePosts, ReadMorePostsProps } from "~/components/ReadMorePosts";
import { ReadMorePostsItems } from "~/components/ReadMorePosts/ReadMorePostsItems";
import { Card } from "~/ui-library";

export type AuthorPageProps = {
  authorHeroProps: AuthorHeroProps;
  readMorePostsProps: Omit<ReadMorePostsProps, "renderItems">;
};

export const AuthorPage: React.FC<AuthorPageProps> = ({
  authorHeroProps,
  readMorePostsProps,
}) => {
  const {
    headshotImageUrl,
    authorName,
    authorTitle,
    authorEmail,
    authorBioHTML,
  } = authorHeroProps;
  return (
    <div className="w-full bg-white lg:pb-[72px]">
      <AuthorHero
        headshotImageUrl={headshotImageUrl}
        authorName={authorName}
        authorTitle={authorTitle}
        authorEmail={authorEmail}
        authorBioHTML={authorBioHTML}
      />

      <Card
        as="section"
        className="top-0 mx-[auto] flex flex-col gap-xs px-s pb-[72px] pt-m last:mb-0 md:px-m md:pb-xxl lg:relative lg:top-[-5rem] lg:max-w-[848px] lg:bg-white lg:p-m [&>*:last-child]:mb-0"
      >
        <ReadMorePosts
          {...readMorePostsProps}
          renderItems={(renderProps) => (
            <ReadMorePostsItems
              {...renderProps}
              className="gap-y-xl"
              imagePosition="top"
              title="Associated Content"
              variant="3-item-row"
            />
          )}
        />
      </Card>
    </div>
  );
};
